export default "__VITE_ASSET__9588c0b9__"